var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conexion completo"},[_c('p',{staticClass:"texto"},[_vm._v(" "+_vm._s(_vm.myProps.customizables.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }